import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-rulz',
    templateUrl: './rulz.component.html',
    styleUrls: ['./rulz.component.css'],
    standalone: false
})
export class RulzComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
